import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 34, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, delay = 0, className = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          className="block"
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            duration: 1.05,
            delay: delay + i * 0.13,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionLabel = ({ num, children }) => (
  <div className="flex items-center gap-3 font-mono-t text-[11px] uppercase tracking-[0.3em] text-rose-500">
    {num && <span className="text-slate-600">{num}</span>}
    <span className="h-px w-8 bg-rose-600/60" />
    <span>{children}</span>
  </div>
);
